/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchApi } from "../utlis/axios";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import { toast } from "react-toastify";
import "./style.css";
import { IoMdClose } from "react-icons/io";
import { BackButton } from "../dashboard/admin/_adminApi";

export const Propertylistingdetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(null);
  const [data, setData] = useState();
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [isEditing, setIsEditing] = useState(false);
  const [step, setStep] = useState(1);
  const [type, setType] = useState("text");
  const [familyData, setFamilyData] = useState();
  const [editedData, setEditedData] = useState({});
  const [familyid, setFamilyId] = useState();
  const [documentId, setDocumentId] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`property/${id}/`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setData(result?.data);
        console.log("member detail :", result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (id) => {
    setIsEditing(true);
    setEditedData({ ...data });
    setFamilyId(id);
  };

  const handleAddProperty = (id) => {
    navigate("/propertyRegistration", { state: { familyId: id } });
  };

  const getFamilydata = async () => {
    try {
      const result = await fetchApi.get(`family/${familyid}`, {
        headers: {
          Authorization: `Bearer ${access}`, // Replace with your API key
        },
      });
      if (result.status === 200) {
        setFamilyData(result.data);
        console.log("Family data...", result.data);
      } else {
        console.error("Failed to fetch data:", result.status);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getFamilydata();
  }, [familyid]);

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      const data = new FormData();
      data.append("id", id);
      data.append("name", editedData?.name);
      data.append("type", editedData?.type);
      data.append("worth", editedData?.worth);
      data.append("owned_since", editedData?.owned_since);
      data.append("description", editedData?.description);
      data.append("pin_location", editedData?.pin_location);
      data.append("family", familyid);
      data.append("is_active", true);

      const result = await fetchApi.patch(`property/${id}/`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        setData({ ...data, ...editedData });
        setIsEditing(false);
        setEditedData({});
        console.log("updated data", result?.data);
      }
      fetchData();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.detail);
    } finally {
      setIsLoading(false);
    }
  };


  const RenderPopup = ({ setShowModal }) => {
    return (
      <div className="fixed inset-0 z-[100] flex justify-center ">
        {/* backdrop */}
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setShowModal(false)}
        ></div>

        {/* modal wrapper */}
        <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
          <div className="relative z-[200] w-full max-w-4xl my-auto">
            <div className="bg-[#FFFFFF] rounded-3xl shadow-xl">
              {/* Close button */}
              <button
                className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer                        hover:text-gray-700 text-2xl"
                onClick={() => setShowModal(false)}
              >
                <IoMdClose />
              </button>

              {/* Header */}
              <div className="px-6 pt-6 pb-4 border-b">
                <h2 className="text-2xl font-semibold text-gray-800">
                  Property Update
                </h2>
              </div>
              <div className="formgroup">
                {loading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh",
                    }}
                  >
                    <Lottie
                      loop={true}
                      animationData={Loader}
                      style={{ width: "200px" }}
                      className="auth-sidebar-video"
                    />
                  </div>
                )}
                {!loading && (
                  <form onSubmit={handleUpdate}>
                    <div className="field_Container">
                      {step === 1 && (
                        <>
                          <div className="group-fields">
                            <div className="field-container">
                              <h6 className="field-txt">Property name</h6>
                              <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Property name"
                                className="formField"
                                value={editedData?.name}
                                onChange={(e) =>
                                  setEditedData({
                                    ...editedData,
                                    name: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div className="field-container">
                              <h6 className="field-txt">Property Type</h6>
                              <select
                                type="text"
                                id="type "
                                name="type "
                                className="formField custom-select"
                                value={editedData?.type}
                                onChange={(e) =>
                                  setEditedData({
                                    ...editedData,
                                    type: e.target.value,
                                  })
                                }
                                required
                                style={{ paddingRight: "70px" }}
                              >
                                <option>Select</option>
                                <option value="Farming Land ">
                                  Farming Land{" "}
                                </option>
                                <option value="5 to 10 lacs">
                                  5 to 10 lacs
                                </option>
                                <option value="Residencial Property(House,Flat, or Plot)">
                                  Residencial Property(House,Flat, or Plot)
                                </option>
                                <option value="Comercial Property(Shop,Comerical Land or plot)">
                                  Comercial Property(Shop,Comerical Land or
                                  plot)
                                </option>
                                <option value="House Holds(Animals, Vehicles)">
                                  House Holds(Animals, Vehicles)
                                </option>
                                <option value="Others">Others</option>
                              </select>
                            </div>
                          </div>

                          <div className="group-fields">
                            <div className="field-container">
                              <h6 className="field-txt">Property worth</h6>
                              <select
                                type="text"
                                id="worth "
                                name="worth "
                                className="formField custom-select"
                                value={editedData?.worth}
                                onChange={(e) =>
                                  setEditedData({
                                    ...editedData,
                                    worth: e.target.value,
                                  })
                                }
                                required
                              >
                                <option>Select</option>
                                <option value="5 lacs or less">
                                  5 lacs or less
                                </option>
                                <option value="5 to 10 lacs">
                                  5 to 10 lacs
                                </option>
                                <option value="10 to 20 lacs">
                                  10 to 20 lacs
                                </option>
                                <option value="20 to 50 lacs">
                                  20 to 50 lacs
                                </option>
                                <option value="50 lacs or more">
                                  50 lacs or more
                                </option>
                              </select>
                            </div>
                            <div className="field-container">
                              <h6 className="field-txt">Property owned since</h6>
                              <input
                                type={type}
                                id="ownd"
                                name="ownd"
                                placeholder="Property owned since"
                                onFocus={(event) => {
                                  event.target.type = "date";
                                }}
                                className="formField"
                                onClick={(e) => setType("date")}
                                value={editedData?.owned_since}
                                onChange={(e) =>
                                  setEditedData({
                                    ...editedData,
                                    owned_since: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                          </div>

                          <div className="group-fields">
                            <div className="field-container">
                              <h6 className="field-txt">Description</h6>
                              <input
                                type="text"
                                id="Description"
                                name="Description"
                                placeholder="Description"
                                className="formField"
                                value={editedData?.description}
                                onChange={(e) =>
                                  setEditedData({
                                    ...editedData,
                                    description: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div className="field-container">
                              <h6 className="field-txt">Location</h6>
                              <input
                                type="text"
                                id="location"
                                name="location"
                                placeholder="Property location"
                                value={editedData?.pin_location}
                                onChange={(e) =>
                                  setEditedData({
                                    ...editedData,
                                    pin_location: e.target.value,
                                  })
                                }
                                className="formField"
                                required
                              />
                            </div>
                          </div>

                          <div className="group-fields">
                            <div className="field-container">
                              <h6 className="field-txt">family</h6>
                              <input
                                type="text"
                                id="family"
                                name="family"
                                placeholder="family"
                                className="formField"
                                value={familyData?.name}
                                // onChange={(e)=> setEditedData({...editedData, description:e.target.value})}
                                required
                                disabled
                              />
                            </div>
                          </div>
                          <div className="next_btn">
                            <button className="primary-button sm:w-[20%] w-full">Update</button>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}
        className="Table_container mt-12 md:px-10 sm:px-4 px-[16px]"
      >
          <BackButton />
        <div className="Table_Section ">
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <Lottie
                loop={true}
                animationData={Loader}
                style={{ width: "200px" }}
                className="auth-sidebar-video"
              />
            </div>
          ) : (
            <>
              <div className="container-small job-details-page-container">
                <div className="main-content-container">
                  <div className="flex justify-between items-center gap-4 px-4 pb-4 border-b border-gray-border">
                    <h1 className="margin-t-16 job-details-title">
                      {data?.name}
                    </h1>
                    <span
                      className="primary-button"
                      onClick={() => handleEditClick(data?.family?.id)}
                    >
                      Edit
                    </span>
                  </div>
                  <div className="info-section ">
                    <h2 className="section-title md:[33%] w-2/5">
                      Family Information
                    </h2>
                    <div className="w-3/5 md:w-[66%]">
                      <div className="info-row">
                        <span className="info-row-label">Family Head</span>
                        <span className="info-row-value">
                          {data?.family?.name}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="info-row-label">Status</span>
                        <span className="info-row-value">
                         <span className=" mt-1 rounded-full py-1 px-2.5 font-semibold text-primary-green border-2 border-primary-green bg-primary-green/10 capitalize">
                            {data?.family?.status}
                            </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="info-section ">
                    <h2 className="section-title md:[33%] w-2/5">
                      Property Information
                    </h2>
                    <div className="w-3/5 md:w-[66%]">
                      <div className="info-row">
                        <span className="info-row-label">Property Type</span>
                        <span className="info-row-value">{data?.type}</span>
                      </div>

                      <div className="info-row">
                        <span className="info-row-label">Property Worth</span>
                        <span className="info-row-value">{data?.worth}</span>
                      </div>

                      <div className="info-row">
                        <span className="info-row-label">
                          Property Description
                        </span>
                        <span className="info-row-value">
                          {data?.description}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="info-row-label">Property Since</span>
                        <span className="info-row-value">
                          {data?.owned_since}
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="info-row-label">Property Location</span>
                        <span className="info-row-value">
                          {data?.pin_location}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {isEditing && <RenderPopup setShowModal={setIsEditing} />}
    </>
  );
};
